import type { BragItem as BragItemType } from './types';
import style from './BragBar.module.scss';
import RichText from '../RichText';
interface BragItemProps {
  item: BragItemType;
  index: number;
}
export default function BragItem({
  item,
  index
}: BragItemProps) {
  if (item.type === 'image' && item.logo) {
    return item.link ? <a target="_blank" rel="noopener noreferrer" href={item.link} key={`brag-item-${index}`}>
				<img className={style.logo} src={item.logo} alt="" data-testid="brag-item" />
			</a> : <img key={`brag-item-${index}`} className={style.logo} src={item.logo} alt="" data-testid="brag-item" />;
  }
  if (item.type === 'text' && item.richText) {
    return <RichText text={item.richText} key={`brag-item-${index}`} data-testid="brag-item" />;
  }
  return null;
}